import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../theme';
import Header from '../pages/header';
import SubHeader from '../pages/sub_header';
import Footer from '../pages/footer';
import { Box, Container } from '@mui/material';
const layout = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ position: 'fixed', top: 0, width: '100%', zIndex: '100' }}>
                <Header />
                <SubHeader />
            </Box>
            <Container
                maxWidth='xl'
                sx={{
                    mt: 18,
                    mb: 10
                }}
            >
                {children}
            </Container>
            <Footer />
        </ThemeProvider>
    );
};

export default layout;
